import type { VeoPlugin } from '../types';

/**
 * Helper de identidad para definir un plugin con inferencia de tipos.
 * No transforma nada; mejora la ergonomía y deja un punto de extensión futuro.
 */
export function definePlugin(plugin: VeoPlugin): VeoPlugin {
  return plugin;
}
